/* Bedrock — Fourchette de volume : poids × coefficient de niveau (+ taille de vague) filtre la grille de planches */
if (!customElements.get('bdr-volume-range')) {
  const rows = (s) =>
    (s || '')
      .split('\n')
      .map((line) => line.split('|').map((x) => x.trim()))
      .filter((l) => l.length === 3 && !isNaN(parseFloat(l[1])) && !isNaN(parseFloat(l[2])));

  // Libellés de taille -> [libellé, volume, ...] via le parseur partagé (bdr-size-table.js).
  const pairs = (labels) => labels.flatMap((l) => [l, ((window.bdrParseSize && window.bdrParseSize(l)) || {}).volume ?? NaN]);

  class BdrVolumeRange extends HTMLElement {
    connectedCallback() {
      this.levels = rows(this.dataset.levels);
      this.waves = rows(this.dataset.waves);
      this.weight = this.querySelector('[name="weight"]');
      this.level = this.querySelector('[name="level"]');
      this.wave = this.querySelector('[name="wave"]');
      // Aucun champ prérempli : « ... » tant que le visiteur n'a rien choisi.
      this.level.add(new Option('...', '', true, true));
      this.levels.forEach(([label], i) => this.level.add(new Option(label, i)));
      if (this.wave) {
        this.wave.add(new Option('...', '', true, true)); // '' -> +'' = 0 : pas de filtre
        this.waves.forEach(([label], i) => this.wave.add(new Option(label, i)));
      }

      this.cards = [...this.querySelectorAll('[data-sizes]')].filter((el) => el.tagName === 'LI');
      this.cards.forEach((c) => {
        c.sizes = pairs(JSON.parse(c.dataset.sizes));
        c.wave = c.dataset.wave.split(',').map(parseFloat);
      });

      this.update = this.update.bind(this);
      this.addEventListener('input', this.update);
      this.addEventListener('change', this.update);
      this.update();

      // Popup de fiche produit : ouverte par tout élément [data-bdr-vr-open], fermée au clic sur le fond.
      const d = this.closest('dialog');
      if (d) {
        document.addEventListener('click', (e) => e.target.closest('[data-bdr-vr-open]') && d.showModal());
        d.addEventListener('click', (e) => e.target === d && d.close());
      }
    }

    update() {
      const w = parseFloat(this.weight.value);
      const lv = this.levels[this.level.value];
      const ready = !!(w && lv);
      const min = ready ? w * parseFloat(lv[1]) : 0;
      const max = ready ? w * parseFloat(lv[2]) : 0;
      const fits = (v) => ready && v >= min && v <= max;
      this.querySelector('[data-zone]').textContent = ready ? `${min.toFixed(1)}–${max.toFixed(1)} L` : '...';
      const empty = this.querySelector('[data-empty]');

      // Fiche produit : tableau complet des cotes, tailles de la fourchette mises en avant
      if (this.dataset.mode === 'product') {
        const s = pairs(JSON.parse(this.querySelector('script[data-sizes]').textContent));
        const list = this.querySelector('[data-list]');
        list.replaceChildren();
        for (let i = 0; i < s.length; i += 2) {
          const li = document.createElement('li');
          li.textContent = s[i];
          li.classList.toggle('is-fit', fits(s[i + 1]));
          list.append(li);
        }
        empty.hidden = !ready || !!list.querySelector('.is-fit');
        return;
      }

      const wi = this.wave ? +this.wave.value : 0;
      const band = this.waves[wi];
      let shown = 0;
      this.cards.forEach((c) => {
        const [lo, hi] = c.wave;
        const waveOk = wi === 0 || (!isNaN(lo) && lo < parseFloat(band[2]) && hi > parseFloat(band[1]));
        const hits = [];
        for (let i = 0; i < c.sizes.length; i += 2) {
          if (fits(c.sizes[i + 1])) hits.push(`${((window.bdrParseSize && window.bdrParseSize(c.sizes[i])) || { length: c.sizes[i] }).length} · ${c.sizes[i + 1]}L`);
        }
        const ok = waveOk && (!ready || hits.length > 0);
        c.hidden = !ok;
        if (ok) {
          shown++;
          c.querySelector('[data-fit]').textContent = ready ? hits.join('  /  ') : '';
        }
      });
      this.querySelector('[data-count]').textContent = shown;
      empty.hidden = shown > 0;
    }
  }
  customElements.define('bdr-volume-range', BdrVolumeRange);
}
